
import Vue, { PropType } from 'vue';
import { ProductColorSetterType } from '@/setters/typings/common/ProductColorsSetterType';
import {
  CvStructuredList,
  CvStructuredListItem,
  CvStructuredListHeading,
  CvStructuredListData,
} from '@carbon/vue';

export default Vue.extend({
  components: {
    CvStructuredList,
    CvStructuredListItem,
    CvStructuredListHeading,
    CvStructuredListData,
  },
  props: {
    productVariants: {
      type: Array as PropType<ProductColorSetterType[]>,
      required: true,
    },
  },
  methods: {
    styleOval(color: string) {
      return 'background-color: ' + color;
    },
  },
});
